import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { saveAs } from 'file-saver-es';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { SegovPage } from 'src/app/app.routes';
import { PaginaJornalOutputDto } from 'src/app/domain/DTOs/output/jornal/pagina-jornal.output.dto';
import { TransferirDadosParaEdicaoDoDiaParams } from 'src/app/domain/routeParamsModels/transferir-dados-para-edicao-do-dia.params';
import { ETipoVisualizacaoMateria } from 'src/app/domain/enums/tipo-visualizacao-materia.enum';
import { baixarPdfMateriaPublicada, baixarPdfMateriaPublicadaFinish } from 'src/app/stateManagement/full-states/publicacao/baixar-pdf-materia-publicada.state';

@Component({
  selector: 'app-listagem-retorno-autenticidade',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './listagem-retorno-autenticidade.component.html',
  styleUrl: './listagem-retorno-autenticidade.component.css'
})
export class ListagemRetornoAutenticidadeComponent implements OnChanges, OnDestroy {
  @Input() PaginaJornalOutputDto?: PaginaJornalOutputDto;
  @Input() public blob = new Blob();

  @Output() ClickCloseOutput = new EventEmitter<void>();

  public readonly tipoVisualizacaoMateria = ETipoVisualizacaoMateria;

  constructor(
    private readonly router: Router,
    private readonly store: Store) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blob'] && changes['blob'].currentValue !== changes['blob'].previousValue &&
      changes['blob'].currentValue && this.blob.size > 0) {
      const visualizarLink = document.getElementById('visualizarPagAutenticidade') as HTMLAnchorElement;
      visualizarLink.href = URL.createObjectURL(this.blob);
      visualizarLink.target = '_blank';
    }
  }

  public clickClose() {
    this.ClickCloseOutput.emit();
  }

  ngOnDestroy(): void {
    this.store.dispatch(baixarPdfMateriaPublicadaFinish());
  }

  public BaixarArquivo() {
    if (this.PaginaJornalOutputDto?.publicacaoId) {
      this.store.dispatch(baixarPdfMateriaPublicada({
        publicacaoId: this.PaginaJornalOutputDto.publicacaoId
      }));
      return;
    }

    this.baixarArquivo(this.blob);
  }

  public visualizarPublicacaoHtml(): void {
    if (!this.PaginaJornalOutputDto?.edicaoId || !this.PaginaJornalOutputDto.cadernoEdicaoId || !this.PaginaJornalOutputDto.publicacaoId)
      return;

    const parametros: TransferirDadosParaEdicaoDoDiaParams = {
      dataPublicacaoSelecionada: this.PaginaJornalOutputDto.dataPublicacao,
      edicaoId: this.PaginaJornalOutputDto.edicaoId,
      idCadernoEdicaoSelecionado: this.PaginaJornalOutputDto.cadernoEdicaoId,
      publicacaoId: this.PaginaJornalOutputDto.publicacaoId
    };
    const url = this.router.serializeUrl(this.router.createUrlTree([SegovPage.EdicaoDoDia], {
      queryParams: { dados: JSON.stringify(parametros) }
    }));
    window.open(url, '_blank', 'noopener');
  }

  private baixarArquivo(blob?: Blob) {
    if (blob) {
      const data = new Date(this.PaginaJornalOutputDto?.dataPublicacao ?? DateTime.local().toJSDate()).toISOString();
      saveAs(blob, `${this.PaginaJornalOutputDto?.descricao ?? "Diario_oficial"}_${data.split('T')[0]}.pdf`);
    }
  }
}
